import { render, staticRenderFns } from "./colorLib.vue?vue&type=template&id=04654758&scoped=true&"
import script from "./colorLib.vue?vue&type=script&lang=js&"
export * from "./colorLib.vue?vue&type=script&lang=js&"
import style0 from "./colorLib.vue?vue&type=style&index=0&id=04654758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04654758",
  null
  
)

export default component.exports